import { render, staticRenderFns } from "./OfficeEmployee.vue?vue&type=template&id=bb3fd776&scoped=true&"
import script from "./OfficeEmployee.vue?vue&type=script&lang=js&"
export * from "./OfficeEmployee.vue?vue&type=script&lang=js&"
import style0 from "./OfficeEmployee.vue?vue&type=style&index=0&id=bb3fd776&lang=scss&scoped=true&"
import style1 from "./OfficeEmployee.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3fd776",
  null
  
)

export default component.exports